export const initDataChange = 'Account/InitDataChangeSession';
export const verifyOtpForDataChange = 'Account/VerifyOtpForDataChangeSession';
export const refreshAuthOtpForDataChange =
  'Account/RefreshAuthOtpForDataChangeSession';
export const updateNewValueForDataChange =
  'Account/UpdateNewValueForDataChangeSession';
export const refreshPerformOtpForDataChange =
  'Account/RefreshPerformOtpForDataChangeSession';
export const performDataChange = 'Account/PerformDataChangeSession';
